import { combineReducers } from "redux";
import alerts from "./Alerts"
import auth from "./Auth"

export default combineReducers({
    alerts,
    auth
});
